export const AuthStatus = {
    Active: 'ACTIVE',
    Locked: 'LOCKED_OUT',
    InvalidOrigin: 'INVALID_ORIGIN',
    Recovering: 'RECOVERY_CHALLENGE',
    Success: 'SUCCESS',
    Unknown: 'UNKNOWN',
    ValidationError: 'VALIDATION_ERROR',
    Staged: 'STAGED'
}